import { ThemeEvents } from '@theme/events';

class StickyAtc extends HTMLElement {
  #observer = null;
  #variantUpdateHandler = null;

  connectedCallback() {
    if (window.matchMedia('(min-width: 750px)').matches) return;

    const productForm = document.querySelector('.product-information product-form-component');
    if (!productForm) return;

    const addButton = productForm.querySelector('button[name="add"]');
    if (!addButton) return;

    const priceEl = this.querySelector('[data-sticky-atc-price]');
    const stickyButton = this.querySelector('.sticky-atc__button');

    this.#syncPrice(priceEl);

    this.#observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            this.setAttribute('data-visible', 'false');
          } else {
            this.setAttribute('data-visible', 'true');
          }
        }
      },
      { threshold: 0, rootMargin: '0px' }
    );
    this.#observer.observe(productForm);

    stickyButton?.addEventListener('click', () => {
      addButton.click();
    });

    this.#variantUpdateHandler = () => {
      this.#syncPrice(priceEl);
    };
    document.addEventListener(ThemeEvents.variantUpdate, this.#variantUpdateHandler);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    document.removeEventListener(ThemeEvents.variantUpdate, this.#variantUpdateHandler);
  }

  #syncPrice(priceEl) {
    if (!priceEl) return;
    const priceSpan = document.querySelector('.product-information .price');
    if (priceSpan) {
      priceEl.textContent = priceSpan.textContent?.trim() || '';
    }
  }
}

if (!customElements.get('sticky-atc')) {
  customElements.define('sticky-atc', StickyAtc);
}
